export default __webpack_public_path__ + "static/media/react.ae626225.svg";